import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

function ReviewCard({ t }) {
  return (
    <div className="w-[280px] sm:w-[350px] shrink-0 card-elevated rounded-2xl p-5 sm:p-6 mr-4 sm:mr-5 flex flex-col hover:-translate-y-1 transition-transform duration-500">
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-0.5">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[#ff5a1f] text-[#ff5a1f]" />)}
        </div>
        <Quote className="w-5 h-5 text-[#e6e1d5]" />
      </div>
      <p className="text-[0.92rem] text-[#4a463d] leading-relaxed flex-1">“{t.text}”</p>
      <div className="mt-5 pt-4 border-t border-black/6 flex items-center gap-3">
        <span className="w-9 h-9 rounded-full bg-[#ff5a1f]/10 text-[#ff5a1f] flex items-center justify-center font-bold text-sm">{t.name.charAt(0)}</span>
        <div>
          <p className="text-sm font-semibold text-[#16150f]">{t.name}</p>
          <p className="text-xs text-[#8a8578] mt-0.5">{t.tag}</p>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const row1 = testimonials.slice(0, 6);
  const row2 = testimonials.slice(6, 12);
  return (
    <section className="py-12 lg:py-28 overflow-hidden">
      <div className="section-pad max-w-[1440px] mx-auto mb-8 sm:mb-14">
        <span className="eyebrow"><span className="dot" /> Client Testimonials</span>
        <div className="mt-4 sm:mt-6 flex flex-col lg:flex-row lg:items-end justify-between gap-4 sm:gap-6">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-[3.6rem] font-extrabold leading-[1.08] tracking-tight max-w-3xl">
            Customer reviews for <span className="font-serif italic font-normal text-accent-orange">VINYLED</span> in Bangalore
          </h2>
          <p className="text-[#5a5548] max-w-sm">Real experiences from vehicle owners who trusted VINYLED for protection, styling and professional installation.</p>
        </div>
      </div>

      <div className="space-y-5 marquee-pause">
        <div className="flex overflow-hidden">
          <div className="flex animate-marquee-slow">{[...row1, ...row1].map((t, i) => <ReviewCard key={i} t={t} />)}</div>
        </div>
        <div className="flex overflow-hidden">
          <div className="flex animate-marquee-right">{[...row2, ...row2].map((t, i) => <ReviewCard key={i} t={t} />)}</div>
        </div>
      </div>
    </section>
  );
}
